<div [hidden]="isShowFlowBuilder" class="cx-one-ui cxone-reporting-set-flow-builder">
    <cv-loader [loaderType]="'cxone'" *ngIf="showSpinner"></cv-loader>

    <div class="toolbar">
        <div class="left-section">
            <button class="btn btn-link" (click)="changeSection(reportingSetSections.LIST)" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Reporting_Set">Reporting Set</button>
            <span cvLocalizedText langSection="ETL_Reporting_Set" langKey="Create_Reporting_Set">Create Reporting Set</span>
        </div>

        <div class="right-section">
            <button class="cxone-btn btn-big btn-secondary btn-bg-is-white" (click)="changeSection(reportingSetSections.LIST)" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Cancel">Cancel</button>
            <button class="cxone-btn btn-big btn-secondary btn-bg-is-white" (click)="handleSave()" [disabled]="saveDisabled" cvLocalizedTextlangSection="ETL_Reporting_Set" langKey="Save">Save</button>
            <button class="cxone-btn btn-big btn-primary btn-bg-is-white" *ngIf="!updateBtnVisiblity" (click)="postReportingSetData(true)"
                    [disabled]="createDisabled || isSaving || !canEdit || (cxoneEtlReportingSet.getReportingSetData() && !cxoneEtlReportingSet.getReportingSetData()?.IsEditable && !canEditLocked)" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Create">Create</button>
            <button class="cxone-btn btn-big btn-primary btn-bg-is-white" *ngIf="updateBtnVisiblity" (click)="postReportingSetData(false)"
                    [disabled]="isUpdateBtnEnable || !canEdit || (cxoneEtlReportingSet.getReportingSetData() && !cxoneEtlReportingSet.getReportingSetData()?.IsEditable && !canEditLocked)" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Update">Update</button>
        </div>
    </div>

    <div class="modules-container">
        <div class="left-section">
            <div class="reporting-set-detail">
                <div class="header">
                    <span class="name" [style]="reportingSetNameStyle"
                        [title]="reportingSetName">{{reportingSetName}}</span>
                    <svg class="icon-16" (click)="redirectToCreateEdit(reportingSetSections.CREATE_EDIT)">
                        <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
                    </svg>
                </div>
                <span class="category">{{category}}</span>
                <span class="description" [title]="description">{{description}}</span>
            </div>
            <div class="reporting-set-sections">
                <cxone-accordion [multiple]="true">
                    <cxone-accordion-tab [header]="joinedFeedsHeader" [selected]="true">
                        <ng-container *ngTemplateOutlet="joinedFeeds"></ng-container>
                    </cxone-accordion-tab>
                    <cxone-accordion-tab [header]="datesHeader" [selected]="true">
                        <ng-container *ngTemplateOutlet="dates"></ng-container>
                    </cxone-accordion-tab>
                    <cxone-accordion-tab [header]="dataFieldsHeader" [selected]="true">
                        <ng-container *ngTemplateOutlet="dataFields"></ng-container>
                    </cxone-accordion-tab>
                    <cxone-accordion-tab [header]="employeeGroupHeader + ' *' " [selected]="true">
                        <cv-employee-group (employeeHierarchyData)="getEmployeeHierarchyData($event)"
                            [selectedSection]="selectedSection" [reportingSetName]="reportingSetName"
                            [hierarchyEmployeeGroupClickedItem]="hierarchyEmployeeGroupClickedItem">
                        </cv-employee-group>
                    </cxone-accordion-tab>
                    <cxone-accordion-tab [header]="contactGroupHeader + ' *' " [selected]="true">
                        <cv-contact-group (contactGroupData)="getContactGroupData($event)"
                            [selectedSection]="selectedSection" [reportingSetName]="reportingSetName"
                            [hierarchyGroupClickedItem]="hierarchyGroupClickedItem">
                        </cv-contact-group>
                    </cxone-accordion-tab>
                    <cxone-accordion-tab [header]="excludeIfHeader" [selected]="true">
                        <ng-container
                            *ngTemplateOutlet="addExcludeIf; context: {source: {name: flowbuilderModules.EXCLUDE_IF}}"></ng-container>
                    </cxone-accordion-tab>
                </cxone-accordion>
            </div>
        </div>
        <div class="right-section" [ngClass]="{'right-section-with-config-pane': isConfigurationPaneActive && selectedSection !== flowbuilderModules.JOINED_FEEDS}">
            <ng-container [ngSwitch]="selectedSection">
                <ng-container *ngSwitchCase="flowbuilderModules.JOINED_FEEDS">
                    <cv-cxone-etl-reporting-set-joined-feed (formValid)="onJoinFeedForms($event)"
                        [reportingSetForm]="reportingSetForm"
                        [reportingSetJoinedFeedsList]="reportingSetJoinedFeedsList"
                        [joinedFeedData]="setjoinedFeedFormData" [permissions]="permissions"
                        *ngIf="isJoinFeedPaneActive"></cv-cxone-etl-reporting-set-joined-feed>
                </ng-container>
                <ng-container *ngIf="isConfigurationPaneActive && selectedSection !== flowbuilderModules.JOINED_FEEDS">
                    <ng-container *ngSwitchCase="flowbuilderModules.DATA_FIELDS">
                        <ng-container *ngTemplateOutlet="treeBuilderTemplate"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="flowbuilderModules.DATES">
                        <ng-container *ngTemplateOutlet="treeBuilderTemplate"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="flowbuilderModules.EMPLOYEE_GROUP">
                        <ng-container *ngTemplateOutlet="treeBuilderTemplate"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="flowbuilderModules.CONTACT_GROUP">
                        <ng-container *ngTemplateOutlet="treeBuilderTemplate"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="flowbuilderModules.EXCLUDE_IF">
                        <ng-container *ngTemplateOutlet="treeBuilderTemplate"></ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!isConfigurationPaneActive">
                    <div class="empty-container" *ngSwitchCase="flowbuilderModules.DEFAULT">
                        <svg>
                            <use href="../App_Themes/CXone/icons/empty-state.svg#empty-state"></use>
                        </svg>
                        <span *ngIf="!updateBtnVisiblity" class="info" cvLocalizedText langSection="ETL_Reporting_Set"
                            langKey="Create_Info">
                            Nothing added yet. Select a field to add.
                        </span>
                        <span *ngIf="updateBtnVisiblity" class="info" cvLocalizedText langSection="ETL_Reporting_Set"
                            langKey="Edit_Info">
                            Select a field to update.
                        </span>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #treeBuilderTemplate>
                <ng-container *ngIf="reportingSetDataFieldComponent && showTreebuilder">
                    <cv-tree-builder #treeBuilder (treeInputClick)="setFormFromTree($event)"
                        [dataFieldRef]="reportingSetDataFieldComponent"></cv-tree-builder>
                </ng-container>
            </ng-template>
        </div>
        <div class="configuration-container" *ngIf="isConfigurationPaneActive && selectedSection !== flowbuilderModules.JOINED_FEEDS">
            <span class="label row">Configuration</span>
            <cv-cxone-reporting-set-data-field [parentForm]="rootForm" [feedName]="feedName"
                [isedit]="updateBtnVisiblity" [reportingSetJoinedFeedsList]="reportingSetJoinedFeedsList"
                [employeeGroupData]="employeeGroupPayload" [contactGroupData]="contactGroupPayload"
                [defaultConfigurationData]="defaultConfigurationData" (outputFormPayload)="initOutputPayload($event)"
                [initializedOutputForm]="parentPayload" [handleEmployeeGroup]="hierarchyEmployeeGroupClickedItem"
                [dataFieldNamesList]="dataFieldNamesList" [handleContactGroup]="hierarchyGroupClickedItem"
                [selectedSection]="selectedSection" [datesFieldNamesList]="datesFieldNamesList"
                (buildedForm)="buildedForm($event)" [modalClose]="isModalClosed" [excludeIfSection]="excludeIfSection"
                (formValid)="handleSaveBtn($event)" (childFormsChanged)="childFormsChanged($event)"
                (formErrors)="validateNameField($event)" [hierarchyGroupClickedItem]="hierarchyGroupClickedItem"
                (validateSaveBtn)="validateSaveBtn($event)" [permissions]="permissions">
            </cv-cxone-reporting-set-data-field>
        </div>
    </div>
</div>
<ng-template #joinedFeeds>
    <ng-container *ngTemplateOutlet="addSectionContainer; context: {source: {name: flowbuilderModules.JOINED_FEEDS}}">
    </ng-container>
    <ng-container *ngFor="let item of reportingSetJoinedFeedsList; let i=index">
        <div id="{{'joined-feeds-group-container-'+i}}" class="list-item"
            [ngClass]="{ 'active': selectedSection == 'joinedFeeds' && item.joinedFeedName === selectedSectionItem }"
            (click)="setjoinedFeedData(item)">
            <span>{{item.joinedFeedName}}</span>
        </div>
    </ng-container>
</ng-template>
<ng-template #dates>
    <ng-container *ngTemplateOutlet="addSectionContainer; context: {source: {name: flowbuilderModules.DATES, isDisable: selectedSection === flowbuilderModules.DATES}}"></ng-container>
    <ng-container *ngFor="let item of datesFieldsObjList; index as i">
        <div id="{{'dates-group-container-'+i}}" class="list-item label-field"
            [ngClass]="{ 'active': selectedSection == 'dates' && datesFieldNamesList[i] === selectedSectionItem }">
            <span class="label tooltip-container" [title]="datesFieldNamesList[i]"
                (click)="backtrackReportingPayload(item, flowbuilderModules.DATES, datesFieldNamesList[i])">{{datesFieldNamesList[i]}}</span>
            <div class="right-icon"
                 *ngIf="(canEdit && cxoneEtlReportingSet.getReportingSetData() && cxoneEtlReportingSet.getReportingSetData()?.IsEditable) || canEditLocked">
                <svg class="icon-16" id="trash-icon-svg" (click)="deleteAddedField(item, 'dates')">
                    <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                </svg>
            </div>
        </div>
    </ng-container>
</ng-template>
<ng-template #dataFields>
    <ng-container *ngTemplateOutlet="addSectionContainer; context: {source: {name: flowbuilderModules.DATA_FIELDS, isDisable: selectedSection === flowbuilderModules.DATA_FIELDS}}"></ng-container>
    <ng-container *ngFor="let item of dataFieldsObjList; index as i">
        <div id="{{'datafields-group-container-'+i}}" class="list-item label-field"
            [ngClass]="{ 'active': selectedSection == 'dataFields' && dataFieldNamesList[i] === selectedSectionItem}">
            <span class="label tooltip-container" [title]="dataFieldNamesList[i]"
                (click)="backtrackReportingPayload(item, flowbuilderModules.DATA_FIELDS, dataFieldNamesList[i])">{{dataFieldNamesList[i]}}</span>
            <div class="right-icon" 
                 *ngIf="(canEdit && cxoneEtlReportingSet.getReportingSetData() && cxoneEtlReportingSet.getReportingSetData()?.IsEditable) || canEditLocked">
                <svg class="icon-16" id="trash-icon-svg" (click)="deleteAddedField(item, 'data fields')">
                    <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                </svg>
            </div>
        </div>
    </ng-container>
</ng-template>
<ng-template #addExcludeIf let-source="source">
    <div class="excludeIf list-item label-field"
        [ngClass]="{'active': selectedSection === flowbuilderModules.EXCLUDE_IF }">
        <button *ngIf="excludeIf" (click)="addSection(source?.name || source);addExclude(null)" class="excludeIf-add"
            cvLocalizedText langSection="ETL_Reporting_Set" langKey="Add_ExcludeIf">Add ExcludeIf</button>
        <button *ngIf="!excludeIf" (click)="editExcludeIf()" class="excludeIf-add" cvLocalizedText
            langSection="ETL_Reporting_Set" langKey="Edit_ExcludeIf">Edit ExcludeIf</button>
    </div>
</ng-template>

<ng-template #addSectionContainer let-source="source">
    <button class="add-section-container list-item" (click)="addSection(source?.name || source)"
        [ngClass]="{ 'active': selectedSection === source && selectedSectionItem === 'new' }"
        [disabled]="!canEdit || (cxoneEtlReportingSet.getReportingSetData() && !cxoneEtlReportingSet.getReportingSetData()?.IsEditable && !canEditLocked)">
        <svg class="icon-16">
            <use href="../App_Themes/CXone/icons/add.svg#add"></use>
        </svg>
        <span cvLocalizedText langSection="ETL_Reporting_Set" langKey="Add">Add</span>
    </button>
</ng-template>
